export default __webpack_public_path__ + "static/Propertymark_CMP_Security_Certificate_2022-7c7c6524501f92bbf0a9f2a9136940a7.pdf";